// src/hooks/useMonitoring.js
import { useState, useEffect } from 'react';
import { collection, onSnapshot, query, where, orderBy, Timestamp } from 'firebase/firestore';
import { db } from '../firebase/firebaseConfig';

/**
 * Subscribes to the monitoring collection for error log and activity data.
 * Only returns events from the last 2 hours.
 */
export const useMonitoring = () => {
  const [events, setEvents] = useState([]);
  const [errors, setErrors] = useState([]);

  useEffect(() => {
    const twoHoursAgo = Timestamp.fromDate(new Date(Date.now() - 2 * 60 * 60 * 1000));
    const q = query(
      collection(db, 'monitoring'),
      where('timestamp', '>', twoHoursAgo),
      orderBy('timestamp', 'desc')
    );

    const unsub = onSnapshot(q, (snap) => {
      const docs = snap.docs.map(d => ({ id: d.id, ...d.data() }));
      setEvents(docs);
      setErrors(docs.filter(d => d.type === 'error'));
    });

    return unsub;
  }, []);

  return { events, errors };
};
